import React, { Component, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import aiva_logo from "./../../assets/aiva_logo_large.jpg";
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Modal,
  Button,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap';
import { BusinessProfile } from '../pages/BussinessProfile';
import Select from 'react-select';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  AxiosAPI,
  getGroupID,
  AxiosStripeAPI,
  getUserID,
  AxiosPublicAPI,
} from '../../helpers/AxiosAPI';
import {
  gAPI_Subscription_By_Group_Id,
  gAPI_BotConversations_list,
  gAPI_AgentConversations_list,
  gAPI_Group_By_Id,
  gAPI_Users_LinkedGrups_By_Id,
  gAPI_Users_LinkedProperties_By_Id,
  putAPI_AgentStatus,
  putAPI_UpdateAgentStatus_By_Id,
} from '../../constants/APIs';
import { reactSelectOptionDiffrentPro } from '../../helpers/Utils';
import {
  setContainerClassnames,
  clickOnMobileMenu,
  logoutUser,
  changeLocale,
  changeProperty,
  getPropertyList,
  changeTimeZone,
  changeCurrency,
  ConnectUser,
  Changecloudbeds,
} from '../../redux/actions';
import {
  menuHiddenBreakpoint,
  searchPath,
  localeOptions,
} from '../../constants/defaultValues';
import timeZoneList from '../../data/timeZoneList';
import { MobileMenuIcon, MenuIcon } from '../../components/svg';
import { getDirection, setDirection } from '../../helpers/Utils';
import Navbar from 'reactstrap/lib/Navbar';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import TopnavEasyAccess from './Topnav.EasyAccess';
import { faHandsHelping } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Intercom from './Intercom';

class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInFullScreen: false,
      searchKeyword: '',
      hotel: { value: '-1', label: 'All' },
      hotelName: 'All',
      propertyList: [],
      stripeCustomerId: '',
      showTwilioConversationList: false,
      showBotConversationOn: false,
      showAgentConversation: false,
      botConversationList: [],
      agentConversationList: [],
      groupsList: [],
      propertiesList: [],
      websiteLink: '',
      rooms: 0,
      starRating: 0,
      bussinessProfileVisible: false,
      type: '',
      groupName: '',
      NotificationTitle: '',
      showLinkedGroups: false,
      loading: false,
      chatInvitations: [],
      showAgentStatus: false,
      agentStatus: false,
      aboutProperty: false,
      propertyList: this.props.plist

    };
    this.audio = new Audio(
      'https://bmbuiassetsprod.blob.core.windows.net/images/chat1.mp3'
    );
  }

  componentWillReceiveProps(props) {
    // if (props.signalRConnection.newConnection !== undefined) {
    //   console.log(
    //     'props.signalRConnection.newConnection.connection',
    //     props.signalRConnection.newConnection.connection._connectionState
    //   );
    // }
    if (
      props.signalRConnection.newConnection !== undefined &&
      this.props.signalRConnection.newConnection === undefined
    ) {
      // props.signalRConnection.newConnection.connection.on(
      //   'newConnection',
      //   (m) => {
      console.log('****** newConnection ******');
      const user = this.props.userData;
      const userProperties = [];
      if (user.properties.length > 0) {
        if (user.properties[0] === '-1') {
          this.props.plist.forEach((p) => {
            userProperties.push(p.id);
          });
        } else {
          user.properties.forEach((p) => {
            userProperties.push(p);
          });
        }
      }

      //     AxiosPublicAPI({
      //       method: 'post',
      //       url: `${process.env.REACT_APP_SIGNALR}/api/AddToGroup`,
      //       data: {
      //         connectionId: m,
      //         recipient: getUserID(),
      //         groupname: userProperties,
      //       },
      //     }).then((resp) => {});
      //   }
      //);

      props.signalRConnection.newConnection.connection
        .invoke('SendMessage', {
          recipient: getUserID(),
          groupname: userProperties,
        })
        .catch(function (err) {
          console.error(err.toString());
        });

      props.signalRConnection.newConnection.connection.on(
        'newChatUserMessage',
        (message) => {
          if (message.Source === 'Visitor' && message.AgentId === getUserID()) {
            this.handleNotificationPopup(message.Content.messages[0]);
            this.audio.play();
            this.setState({ showAgentConversation: true });
          }
        }
      );

      props.signalRConnection.newConnection.connection.on(
        'newChat',
        (message) => {
          this.audio.play();
          this.setState({ showBotConversationOn: true });
        }
      );

      props.signalRConnection.newConnection.connection.on(
        'newAgentChat',
        (message) => {
          if (this.state.agentStatus) {
            AxiosAPI({
              method: 'put',
              url: `${putAPI_UpdateAgentStatus_By_Id}/${message}`,
              data: {
                groupId: getGroupID(),
                userId: getUserID(),
                status: 'RequestReceived',
              },
            });

            const checkConversations = this.state.chatInvitations.filter(
              (m) => m === message
            );
            if (checkConversations.length === 0) {
              this.handleNotificationPopup('New chat request arrived');
              this.setState({
                chatInvitations: [message, ...this.state.chatInvitations],
              });
              this.audio.play();
              this.setState({ showAgentConversation: true });
            }
          }
        }
      );
    }
  }
  acceptChat(id) {
    console.log(id);
    var array = [...this.state.chatInvitations]; // make a separate copy of the array
    var index = array.indexOf(id);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ chatInvitations: array });
    }
    //this.props.history.push('/app/pages/conversations/active');
    this.props.history.push({
      pathname: '/app/pages/conversations/active',
      state: { incomingchatId: id },
    });
  }
  componentDidMount() {
    if (this.props.userRole != undefined && this.props.userRole === 'View') {
      setTimeout(() => {
        var event = document.createEvent('HTMLEvents');
        event.initEvent('resize', false, false);
        window.dispatchEvent(event);
      }, 350);
      this.props.setContainerClassnames(
        ++this.state.menuClickCount,
        this.state.containerClassnames,
        this.props.selectedMenuHasSubItems
      );
    }

    if (window.location.href.includes("/app/pages/tokens") === false && window.location.href.includes("/app/pages/cloudbeds") === false && this.props.cloudBedsCode !== undefined && this.props.cloudBedsCode != '') {
      //localStorage.removeItem("cloudbeds");      
      window.location.href = "/app/pages/tokens" + this.props.cloudBedsCode;
    }
    this.setHotelName(this.props.pid);
    this.setNotification();
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Subscription_By_Group_Id}?groupid=${getGroupID()}`,
    }).then((subscriptionResponse) => {
      if (
        subscriptionResponse.data.stripeCustomerId === null ||
        subscriptionResponse.data.stripeCustomerId === ''
      ) {
      } else {
        this.setState({
          stripeCustomerId: subscriptionResponse.data.stripeCustomerId,
        });
      }
    });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_LinkedGrups_By_Id}?id=${getUserID()}&bmb=false&aiva=true`,
    }).then((gresponse) => {
      this.setState({ groupsList: gresponse.data });
    });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_LinkedProperties_By_Id}?id=${getUserID()}&bmb=true&aiva=true`,
    }).then((response) => {
      this.setState({ propertiesList: response.data });
      console.log(response.data.filter((f) => f.groupId === getGroupID() && f.id === this.props.propertyId));
    });

  }

  RefreshConversations = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_BotConversations_list}?gid=${getGroupID()}&pid=${this.props.pid
        }`,
    }).then((botresponse) => {
      // console.log(botresponse.data)
      if (botresponse.data.length > 0) {
        // console.log(this.state.botConversationList)
        // this.setState({ botConversationList: [...this.state.botConversationList, ...botresponse.data] })
        // this.setState({ showBotConversationOn: true })

        //if (this.state.showBotConversationOn === false) {
        this.audio.play();
        //}
        this.setState({ showBotConversationOn: true });
        botresponse.data.map((element, index) => {
          this.handleNotificationPopup(element.message);
        });
      } else {
        // this.setState({ showBotConversationOn: false })
      }
    });

    AxiosAPI({
      method: 'get',
      url: `${gAPI_AgentConversations_list}?gid=${getGroupID()}&pid=${this.props.pid
        }`,
    }).then((botresponse) => {
      //console.log(botresponse.data)
      this.setState({
        agentConversationList: [
          ...this.state.botConversationList,
          ...botresponse.data,
        ],
      });
      if (botresponse.data.length > 0) {
        // if (this.state.showAgentConversation === false) {
        this.audio.play();
        // }
        botresponse.data.map((element, index) => {
          this.handleNotificationPopup(element.message);
        });
        this.setState({ showAgentConversation: true });
      } else {
        // this.setState({ showAgentConversation: false })
      }
    });
  };

  setHotelName = (id) => {
    //console.log(this.props.plist)
    const hotel = this.props.plist.find((elem) => {
      return elem.id === id;
    });
    if (hotel) {
      // console.log(hotel);
      const name = hotel.name;
      const websiteLink = hotel.websiteLink;
      const rooms = hotel.rooms;
      const starRating = hotel.starRating;
      const type = hotel.type;
      const groupName = hotel.groupName;
      this.props.changeProperty(id);
      this.props.changeCurrency(hotel.currency);
      this.props.changeTimeZone(hotel.timeZone);
      this.setState({
        hotelName: name,
        websiteLink: websiteLink,
        rooms: rooms,
        starRating: starRating,
        type: type,
        groupName: groupName,
      });
    } else {
      console.log('not found');
      // this.props.changeProperty(this.state.propertyList[0].id);
      // this.setState({ hotelName: this.state.propertyList[0].name });
    }
  };

  handleChangeLocale = (locale, direction) => {
    this.props.changeLocale(locale);

    // const currentDirection = getDirection().direction;
    // if (direction !== currentDirection) {
    //   setDirection(direction);
    setTimeout(() => {
      window.location.reload();
    }, 500);
    //}
  };

  toggleBussinessPopup = (e) => {
    e.preventDefault();
    this.setState({
      bussinessProfileVisible: !this.state.bussinessProfileVisible,
    });
  }

  toggleUserNotifications = (e) => {
    e.preventDefault();
    window.location.href = '/app/pages/admin';
  }
  handleChangePropertyID = (propertyId, timeZone, currency) => {
    this.props.changeProperty(propertyId);
    this.props.changeTimeZone(timeZone);
    this.props.changeCurrency(currency);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };
  handleChangeSelect = (e) => {
    this.setState({ loading: true });
    const groupId = e.value;
    const AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
    window.location.href = `${AUTHORITY_SERVER}/Aiva/SwitchGroup/${getUserID()}?groupId=${groupId}`;
  };
  handleBMBRedirect = () => {
    this.setState({ loading: true });
    const AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
    window.location.href = `${AUTHORITY_SERVER}/Account/SwitchGroup/${getUserID()}?groupId=${getGroupID()}`;
  };
  handleChangePropertyIDAll = () => {
    this.props.changeProperty('-1');
    // AxiosAPI({
    //   method: 'get',
    //   url: `${gAPI_Group_By_Id}/${getGroupID()}`,
    // })
    //   .then(res => {
    //     console.log(res.data)
    //     let timeZones = timeZoneList.filter(item => item.IsoAlpha2 === res.data.country);
    //     if (timeZones.length > 0) {
    //       this.props.changeTimeZone(timeZones[0].TimeZones[0]);
    //       this.props.changeCurrency(res.data.currency);
    //       // setTimeout(() => {
    //       //   window.location.reload();
    //       // }, 500);
    //     }
    //   });
    this.props.changeTimeZone('Etc/GMT');
    this.props.changeCurrency('');
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  isInFullScreen = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };
  handleSearchIconClick = (e) => {
    if (window.innerWidth < menuHiddenBreakpoint) {
      let elem = e.target;
      if (!e.target.classList.contains('search')) {
        if (e.target.parentElement.classList.contains('search')) {
          elem = e.target.parentElement;
        } else if (
          e.target.parentElement.parentElement.classList.contains('search')
        ) {
          elem = e.target.parentElement.parentElement;
        }
      }

      if (elem.classList.contains('mobile-view')) {
        this.search();
        elem.classList.remove('mobile-view');
        this.removeEventsSearch();
      } else {
        elem.classList.add('mobile-view');
        this.addEventsSearch();
      }
    } else {
      this.search();
    }
  };
  addEventsSearch = () => {
    document.addEventListener('click', this.handleDocumentClickSearch, true);
  };
  removeEventsSearch = () => {
    document.removeEventListener('click', this.handleDocumentClickSearch, true);
  };

  handleDocumentClickSearch = (e) => {
    let isSearchClick = false;
    if (
      e.target &&
      e.target.classList &&
      (e.target.classList.contains('navbar') ||
        e.target.classList.contains('simple-icon-magnifier'))
    ) {
      isSearchClick = true;
      if (e.target.classList.contains('simple-icon-magnifier')) {
        this.search();
      }
    } else if (
      e.target.parentElement &&
      e.target.parentElement.classList &&
      e.target.parentElement.classList.contains('search')
    ) {
      isSearchClick = true;
    }

    if (!isSearchClick) {
      const input = document.querySelector('.mobile-view');
      if (input && input.classList) input.classList.remove('mobile-view');
      this.removeEventsSearch();
      this.setState({
        searchKeyword: '',
      });
    }
  };
  handleSearchInputChange = (e) => {
    this.setState({
      searchKeyword: e.target.value,
    });
  };
  handleSearchInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.search();
    }
  };

  handleAgentConversationClick = (e) => {
    this.setState({ showAgentConversation: false });
    // this.setState({
    //   showTwilioConversationList: true,
    // });
    this.props.history.push('/app/pages/conversations/active');
  };

  search = () => {
    this.props.history.push(searchPath + '/' + this.state.searchKeyword);
    this.setState({
      searchKeyword: '',
    });
  };

  toggleSwitchAccount = () => {
    this.setState({
      showLinkedGroups: !this.state.showLinkedGroups,
    });
  };

  twilioStartChat = () => {
    this.setState({
      showTwilioConversationList: true,
    });
  };

  toggleFullScreen = () => {
    const isInFullScreen = this.isInFullScreen();

    var docElm = document.documentElement;
    if (!isInFullScreen) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    this.setState({
      isInFullScreen: !isInFullScreen,
    });
  };

  handleChangePassword = () => {
    this.props.history.push('/app/pages/users/change-password');
  };

  handleChangePin = () => {
    this.props.history.push('/app/pages/users/change-pin');
  };

  onSearchKey = (e) => {
    var serachtext = e.target.value.toLowerCase();
    var resdata = this.props.plist.filter(a => a.name.toLowerCase().includes(serachtext));
    this.setState({ propertyList: resdata });
  };

  handleSubscription = () => {
    this.props.history.push('/app/pages/billing/subscription');
  };

  handleLatestBotConversation = () => {
    this.setState({ showBotConversationOn: false });
    this.props.history.push('/app/pages/conversations/active');
  };

  handleInvoices = () => {
    this.StripeCustmerPortal(this.state.stripeCustomerId);
  };

  StripeCustmerPortal = (customerID) => {
    var qs = require('qs');
    var data = qs.stringify({
      customer: customerID,
      return_url: window.location.href,
    });
    AxiosStripeAPI({
      method: 'post',
      url: `v1/billing_portal/sessions`,
      data: data,
    }).then((stripeResponse) => {
      window.open(
        stripeResponse.data.url,
        '_blank' // <- This is what makes it open in a new window.
      );
    });
  };

  handleLogout = (e) => {
    this.props.Changecloudbeds('');
    // this.props.logoutUser(this.props.history);
    e.preventDefault();
    const AUTHORITY_SERVER = process.env.REACT_APP_AUTHORITY_SERVER;
    let id_token = JSON.parse(
      sessionStorage.getItem(
        `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
      )
    ).id_token;
    //this.props.history.push(`${AUTHORITY_SERVER}/Account/Logout?logoutId=${id_token}`)
    window.location.href = `${AUTHORITY_SERVER}/Aiva/Logout?logoutId=${id_token}`;
    // userManager.signoutRedirect();
    // userManager.removeUser();
  };

  handlePrivacy = (e) => {
    e.preventDefault();
    window.open('https://www.myma.ai/privacy-policy');
  };

  handleHelpCenter=(e)=>{
    e.preventDefault();
    window.open('https://help.myma.ai/en/collections/5437506-aiva-ai-voucher-e-gift-solution', '_blank');
  }

  handleWebsiteLink = (e) => {
    e.preventDefault();
    window.open(this.state.websiteLink);
  };
  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    e.preventDefault();

    setTimeout(() => {
      var event = document.createEvent('HTMLEvents');
      event.initEvent('resize', false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };
  mobileMenuButtonClick = (e, containerClassnames) => {
    e.preventDefault();
    this.props.clickOnMobileMenu(containerClassnames);
  };

  setNotification = () => {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
    } else if (Notification.permission === 'granted') {
      this.setState({ NotificationTitle: '' });
    } else {
      this.setState({ NotificationTitle: 'Allow Notification' });
    }
  };
  handleNotificationPopup = (msg) => {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
    } else if (Notification.permission === 'granted') {
      this.setState({ NotificationTitle: '' });
      //var notification = new Notification(msg);
      var img =
        'https://bmbuiassetsprod.blob.core.windows.net/images/newlogo.png';
      var notification = new Notification('Book Me Bob', {
        body: msg,
        icon: img,
      });
      notification.onclick = function (x) {
        window.focus();
        window.location.href = '/app/pages/conversations/active';
        this.close();
      };
      setTimeout(notification.close(), 1 * 1000);
    } else if (
      Notification.permission === 'denied' ||
      Notification.permission === 'default'
    ) {
      Notification.requestPermission(function (permission) {
        if (permission === 'granted') {
          var img =
            'https://bmbuiassetsprod.blob.core.windows.net/images/newlogo.png';
          var notification = new Notification('Aiva', {
            body: msg,
            icon: img,
          });
          notification.onclick = function (x) {
            window.focus();
            window.location.href = '/app/pages/conversations/active';
            this.close();
          };
          setTimeout(notification.close(), 1 * 1000);
        } else {
          Notification.requestPermission(function (per) {
            console.log(per);
          });
        }
      });
    }
  };
  handleAllowNotification = () => {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
    } else {
      Notification.requestPermission().then(function (permission) {
        console.log(permission);
      });
      console.log(Notification.permission);
      this.setState({ NotificationTitle: '' });
    }
  };
  handleSwitchChange = (value) => {
    console.log(value);
    AxiosAPI({
      method: 'put',
      url: `${putAPI_AgentStatus}/${getUserID()}/agent-status`,
      data: { status: value },
    }).then((subscriptionResponse) => {
      console.log('Status changed');
    });
    this.setState({ agentStatus: value });
  };
  rejectChat = (id) => {
    var array = [...this.state.chatInvitations]; // make a separate copy of the array
    var index = array.indexOf(id);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ chatInvitations: array });
    }
  };

  redirectToRedeemVouchers=()=>{    
    window.location.href ="/app/pages/redeemVouchers";
  }
  render() {
    const {
      containerClassnames,
      menuClickCount,
      locale,
      user,
      usersListApp: { properties },
      role,
      signalRConnection,
    } = this.props;

    let GROUP_ID = JSON.parse(
      sessionStorage.getItem(
        `oidc.user:${process.env.REACT_APP_AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
      )
    ).profile.nickname;
    const { messages } = this.props.intl;
        
    return (
      <Fragment>
        <nav className="navbar fixed-top">
          <div className="d-flex align-items-center navbar-left">
            {this.props.userRole !== undefined && this.props.userRole === 'View' ? null :
              <Fragment>
                <NavLink
                  to="#"
                  className="menu-button d-none d-md-block"
                  onClick={(e) =>
                    this.menuButtonClick(e, menuClickCount, containerClassnames)
                  }
                >
                  <MenuIcon />
                </NavLink>
                <NavLink
                  to="#"
                  className="menu-button-mobile d-xs-block d-sm-block d-md-none"
                  onClick={(e) =>
                    this.mobileMenuButtonClick(e, containerClassnames)
                  }
                >
                  <MobileMenuIcon />
                </NavLink>
              </Fragment>}

            <div className="d-inline-block">
              <UncontrolledDropdown className="ml-2">
                <DropdownToggle
                  caret
                  color="light"
                  size="sm"
                  className="language-button"
                >
                  <span className="name">{this.state.hotelName}</span>
                </DropdownToggle>
                <DropdownMenu
                  style={{ maxHeight: '500px', overflowY: 'auto',minWidth:'225px' }}
                  className="mt-3"
                  right
                >
                  <div className='search-property'>
                    <input type="text" placeholder='Search Business...' onKeyUp={(e) => this.onSearchKey(e)}></input>
                  </div>
                  {this.props.plist && this.props.plist.length > 1 && (
                    <DropdownItem
                      onClick={() => this.handleChangePropertyIDAll()}
                    >
                      All
                    </DropdownItem>
                  )}
                  {this.props.plist
                    ? this.state.propertyList.sort(function (a, b) {
                      if (a.name < b.name) { return -1; } if (a.name > b.name) { return 1; } return 0;
                    }).sort((a, b) => a.name - b.name).map((element, index) => {
                      if (element.isAiva === true) {
                        return (
                          <DropdownItem
                            onClick={() =>
                              this.handleChangePropertyID(
                                element.id,
                                element.timeZone,
                                element.currency
                              )
                            }
                            key={index}
                          >
                            {element.name}
                          </DropdownItem>
                        );
                      }
                    })
                    : []}
                </DropdownMenu>
                {/* <DropdownMenu className="mt-3" right>
                {properties
                  ? reactSelectOption(properties, true).map(
                      (element, index) => {
                        return (
                          <DropdownItem
                            onClick={() =>
                              this.handleChangeLocale(
                                element.value,
                                element.label
                              )
                            }
                            key={index}
                          >
                            {element.label}
                          </DropdownItem>
                        );
                      }
                    )
                  : []}
              </DropdownMenu> */}
              </UncontrolledDropdown>
            </div>

            <div className="d-inline-block">
              <UncontrolledDropdown className="ml-2">
                <DropdownToggle
                  caret
                  color="light"
                  size="xs"
                  className="language-button"
                >
                  <span className="name">{locale.toUpperCase()}</span>
                </DropdownToggle>
                <DropdownMenu className="mt-3" right>
                  {localeOptions.map((elem, index) => {
                    return (
                      <DropdownItem
                        onClick={() =>
                          this.handleChangeLocale(elem.id, elem.direction)
                        }
                        key={index}
                      >
                        {elem.name}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>
          {window.innerWidth > 700 &&
          <a className="navbar-logo d-none" href="/">
            <img
              src={aiva_logo}
              className='dashboard-logo'
              width={100}

              alt="logo"
            />
          </a>}
          <div className="navbar-right">
            {/* {isDarkSwitchActive && <TopnavDarkSwitch />} */}
            <div className="header-icons d-inline-block align-middle">

               <Fragment>
                {window.innerWidth > 700 ?
                 <Button style={{marginTop:'-0.25rem', padding :'0.25rem 1rem 0.25rem 1rem'}} onClick={this.redirectToRedeemVouchers} color='secondary'>Redeem</Button>:
                 <Button style={{padding :'0.25rem 1rem 0.25rem 1rem'}} onClick={this.redirectToRedeemVouchers} color='secondary'>R</Button>}
               </Fragment>

              <Fragment>{this.props.userRole !== undefined && this.props.userRole === 'View' ? null : <Fragment>
                {this.state.propertiesList !== undefined && this.state.propertiesList.length > 0 &&
                  this.state.propertiesList.filter((f) => f.groupId === getGroupID() && f.id === this.props.propertyId).length > 0
                  && <TopnavEasyAccess handleAivaRedirect={this.handleBMBRedirect} />}
              </Fragment>}
              </Fragment>

              {/* <TopnavNotifications /> */}

              {this.state.showAgentStatus && (
                <Fragment>
                  {this.state.showBotConversationOn === true && (
                    <a
                      onClick={this.handleLatestBotConversation}
                      className="header-icon d-sm-inline-block"
                      title="Active Conversations"
                    >
                      <img
                        src="/assets/img/bot-on.png"
                        width={25}
                        height={25}
                        className="blink"
                      />{' '}
                    </a>
                  )}

                  {this.state.showBotConversationOn === false && (
                    <a
                      onClick={this.handleLatestBotConversation}
                      className="header-icon d-sm-inline-block"
                      title="Active Conversations"
                    >
                      <img
                        src="/assets/img/bot-off.png"
                        width={25}
                        height={25}
                      />{' '}
                    </a>
                  )}

                  {this.state.showAgentConversation === true && (
                    <a
                      onClick={this.handleAgentConversationClick}
                      className="header-icon d-sm-inline-block"
                      title="Agent Conversations"
                    >
                      <img
                        src="/assets/img/agent-on.png"
                        width={25}
                        height={25}
                        className="blink"
                      />{' '}
                    </a>
                  )}

                  {this.state.showAgentConversation === false && (
                    <a
                      onClick={this.handleAgentConversationClick}
                      className="header-icon d-sm-inline-block"
                      title="Agent Conversations"
                    >
                      <img
                        src="/assets/img/agent-off.png"
                        width={25}
                        height={25}
                      />{' '}
                    </a>
                  )}
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-3 d-sm-inline-block"
                    checked={this.state.agentStatus}
                    onChange={(primary) => this.handleSwitchChange(primary)}
                  />
                  {this.state.agentStatus ? (
                    <span
                      className="ml-2 align-bottom"
                      style={{ fontSize: '0.8rem' }}
                    >
                      Online{' '}
                    </span>
                  ) : (
                    <span
                      className="ml-2 align-bottom"
                      style={{ fontSize: '0.8rem' }}
                    >
                      Offline{' '}
                    </span>
                  )}
                </Fragment>
              )}
            </div>

            <div className="user d-inline-block">
              <UncontrolledDropdown className="dropdown-menu-right">
                <DropdownToggle className="p-0" color="empty">
                  <span className="name mr-1">{user && user.profile.name}</span>
                  <button
                    className="header-icon btn btn-empty d-none d-sm-inline-block"
                    id="fullScreenButton"
                    onClick={this.toggleFullScreen}
                  >
                    {this.state.isInFullScreen ? (
                      <i className="simple-icon-size-actual d-block" />
                    ) : (
                      <i className="simple-icon-size-fullscreen d-block" />
                    )}
                  </button>
                  <button
                    className="header-icon btn btn-empty d-sm-inline-block"
                    type="button"
                  >
                    <i
                      className="d-block simple-icon-settings"
                      id="nametip"
                    ></i>
                  </button>

                  <button
                    className="header-icon btn btn-empty d-sm-inline-block help-icon"
                    id="helpHand"                    
                    onClick={(e)=> this.handleHelpCenter(e)}
                  > ?                    
                  </button>
                </DropdownToggle>
                <DropdownMenu className="mt-3" right  style={{minWidth:"250px"}}>
                  {/* <DropdownItem>Account</DropdownItem>
                <DropdownItem>Features</DropdownItem>
                <DropdownItem>History</DropdownItem> */}
                  <DropdownItem>
                    <div class="user-info">
                       <div className='row'>
                        <div className='col-md-2 round-name'>
                           <b>{(user && user.profile.name) && <Fragment>                            
                            {user.profile.name.split(' ').length > 1 ?
                             user.profile.name.split(' ')[0][0]+
                             user.profile.name.split(' ')[1][0]
                            : 
                             user.profile.name[0]+user.profile.name[1]
                            }
                            </Fragment>}
                            </b>
                        </div>
                        <div className='col-md-9'>
                          <p>Hello,</p>
                          <h5><b>{user && user.profile.name}</b></h5>
                        </div>
                       </div>
                    </div>
                  </DropdownItem>
                  {/* {this.state.stripeCustomerId !== '' && role === 'Admin' && (
                    <Fragment>
                      <DropdownItem onClick={(e) => this.handleInvoices(e)}>
                        {' '}
                        Invoice & payments
                      </DropdownItem>
                      <DropdownItem onClick={(e) => this.handleSubscription(e)}>
                        {' '}
                        Upgrade plan
                      </DropdownItem>
                    </Fragment>
                  )} */}
                  <DropdownItem onClick={(e) => this.handleChangePassword(e)}>
                    {' '}
                    Change Password
                  </DropdownItem>
                  <DropdownItem onClick={(e) => this.handleLogout(e)}>
                    Sign Out
                  </DropdownItem>
                  <DropdownItem divider />                  
                  <DropdownItem onClick={(e) => this.handlePrivacy(e)}>
                    Privacy Policy
                  </DropdownItem>
                  <DropdownItem onClick={(e) => this.handleHelpCenter(e)}>
                    Help Center
                  </DropdownItem>
                  <DropdownItem divider />
                  {this.state.groupsList.length > 1 && (
                    <Fragment>
                      {' '}
                      {/* <DropdownItem divider /> */}
                      <DropdownItem onClick={(e) => this.toggleSwitchAccount()}>
                        Switch Account
                      </DropdownItem>
                    </Fragment>
                  )}
                  {/* <DropdownItem divider /> */}
                  {(this.props.userRole !== undefined && this.props.userRole === 'View' &&
                    this.props.checkPin === true) &&
                    <DropdownItem onClick={(e) => this.handleChangePin(e)}>
                      {' '}
                      Change Pin
                    </DropdownItem>}
                  {(this.props.userRole != undefined && this.props.userRole === 'View' &&
                    this.props.checkPin === false) &&
                    <DropdownItem onClick={(e) => this.handleChangePin(e)}>
                      {' '}
                      Create Pin
                    </DropdownItem>
                  }                                    
                 
                  
                  {role === 'Admin' && (
                    <Fragment>
                      <DropdownItem divider />
                      <DropdownItem onClick={(e) => this.toggleBussinessPopup(e)}>
                        Business Profile
                      </DropdownItem>
                      <DropdownItem onClick={(e) => this.toggleUserNotifications(e)}>
                        User & Notifications
                      </DropdownItem>
                      {this.state.stripeCustomerId !== '' &&
                      <DropdownItem onClick={(e) => this.handleInvoices(e)}>
                        {' '}
                        Invoice & Payments
                      </DropdownItem>}
                      {this.state.stripeCustomerId !== '' && <DropdownItem onClick={(e) => this.handleSubscription(e)}>
                        {' '}
                        Upgrade Plan
                      </DropdownItem>}
                    </Fragment>
                  )}
                  <DropdownItem divider />
                  {/* {this.props.userRole === 'View' ? null : <span className="dropdown-item pb-0 pt-0">
                    {this.props.propertyId !== "-1" && (
                      <a className="btn-link"
                        onClick={(e) => this.toggleBussinessPopup(e)}
                        style={{ textDecoration: 'underline', cursor: "pointer" }}>
                        Business Profile
                      </a>
                    )}
                  </span>} */}
                  <span className="dropdown-item pb-0 pt-0">
                    {this.state.hotelName}
                  </span>
                  <span className="dropdown-item pb-0 pt-0">
                    Type: {this.state.type}
                  </span>
                  <span className="dropdown-item pb-0 pt-0">
                    <a
                      onClick={(e) => this.handleWebsiteLink(e)}
                      className="btn-link"
                      style={{ textDecoration: 'underline' }}
                    >
                      {this.state.websiteLink}
                    </a>
                  </span>
                  <span
                    className="dropdown-item pb-0 pt-0"
                    style={{ display: this.state.rooms > 0 ? 'block' : 'none' }}
                  >
                    Rooms: {this.state.rooms}
                  </span>
                  <span
                    className="dropdown-item pb-0 pt-0"
                    style={{
                      display: this.state.starRating > 0 ? 'block' : 'none',
                    }}
                  >
                    Star Rating: {this.state.starRating}
                  </span>
                  <span className="dropdown-item pt-0">
                    Group: {this.state.groupName}
                  </span>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>
        </nav>

        <Modal
          isOpen={this.state.showLinkedGroups}
          keyboard="false"
          backdrop="static"
          toggle={this.toggleSwitchAccount}
        >
          <ModalHeader>Choose the Group to Switch</ModalHeader>
          <ModalBody>
            {this.state.loading ? (
              <div>
                <Spinner color="primary" className="mb-1" />
                <p>Your request is in progress</p>
              </div>
            ) : (
              <Select
                isMulti={false}
                className="react-select"
                classNamePrefix="react-select"
                name="id"
                placeholder="Select Group"
                onChange={(e) => this.handleChangeSelect(e)}
                options={
                  this.state.groupsList
                    ? reactSelectOptionDiffrentPro(
                      this.state.groupsList,
                      true,
                      'groupId',
                      'name',
                      ''
                    )
                    : []
                }
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleSwitchAccount}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        {this.state.chatInvitations.length > 0 && (
          <Fragment>
            <div className="ongoing">
              <ul style={{ float: 'right' }}>
                {this.state.chatInvitations.map((person, i) => (
                  <div className="msg_box" style={{ right: `${270 * i}px` }}>
                    <div className="msg_head">
                      <div
                        className="chatclose"
                        onClick={() => this.rejectChat(person)}
                      >
                        x
                      </div>
                    </div>
                    <div className="msg_wrap">
                      <div className="msg_body">
                        <p>
                          User requested to chat with the agent. Please click
                          accept to connect to conversation or click cancel to
                          close the request{' '}
                        </p>
                        <p>
                          <Button
                            color="primary"
                            outline
                            size="xs"
                            onClick={() => this.acceptChat(person)}
                            style={{ borderRadius: '6px' }}
                          >
                            Accept
                          </Button>{' '}
                          <Button
                            color="secondary"
                            outline
                            size="xs"
                            onClick={() => this.rejectChat(person)}
                            style={{ borderRadius: '6px' }}
                          >
                            Cancel
                          </Button>{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            </div>
          </Fragment>
        )}
        <BusinessProfile
          visible={this.state.bussinessProfileVisible}
          toggle={() => {
            this.setState({ bussinessProfileVisible: false });
          }}
          propertyId={this.props.propertyId}
          groupId={getGroupID()}></BusinessProfile>
        <Intercom></Intercom>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  menu,
  settings,
  oidc,
  usersListApp,
  signalRConnection,
}) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  const { locale, propertyId, cloudBedsCode, userRole, checkPin } = settings;
  return {
    cloudBedsCode,
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    locale,
    propertyId,
    user: oidc.user,
    usersListApp,
    userRole,
    signalRConnection,
    checkPin
  };
};
export default injectIntl(
  connect(mapStateToProps, {
    setContainerClassnames,
    clickOnMobileMenu,
    logoutUser,
    changeLocale,
    changeProperty,
    changeTimeZone,
    changeCurrency,
    getPropertyList,
    ConnectUser,
    Changecloudbeds
  })(TopNav)
);
